<template>
  <section class="reseller-table">
    <table>
      <colgroup>
        <slot name="table-col"></slot>
      </colgroup>
      <thead>
        <tr>
          <slot name="table-header"></slot>
        </tr>
      </thead>
      <tbody>
        <slot name="table-body"></slot>
      </tbody>
    </table>
    <slot name="showmore"></slot>
    <slot name="contents"></slot>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
